import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const ServerError: FC = () => {

  var currentTheme = useTheme();
  const mobileDevice = useMediaQuery(useTheme().breakpoints.down('sm'));
  const { t } = useTranslation();

  return (
    <>
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: 'background.default',
          display: 'flex',
          minHeight: '100%',
          px: 3,
          py: '80px',
          [currentTheme.breakpoints.up('lg')]: {
            paddingLeft: '300px'
          }
        }}
      >
        <Container maxWidth="lg">
          <Typography
            align="center"
            color="textPrimary"
            variant={mobileDevice ? 'h4' : 'h1'}
          >
            {t('INTERNAL_SERVER_ERROR')}
          </Typography>
          <Typography
            align="center"
            color="textSecondary"
            sx={{ mt: 0.5 }}
            variant="subtitle2"
          >
            {t('INTERNAL_SERVER_ERROR_DESCRIPTION')}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 6
            }}
          >
            <Box
              alt="Under development"
              component="img"
              src={`/static/error500_dark.svg`}
              sx={{
                height: 'auto',
                maxWidth: '100%',
                width: 400
              }}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 6
            }}
          >
            <Button
              color="primary"
              component={RouterLink}
              to="/"
              variant="outlined"
            >
              {t('BACK_TO_DASHBOARD')}
            </Button>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default ServerError;
